import { useState } from 'react';
import { useProject } from '../project-hooks/useProject';
import CountUp from 'react-countup';
import { formatNumber } from '../../utils';

const CollectedAmountAnimated = ({ formattingFn = formatNumber, duration = 1.5 }) => {
    const project = useProject();
    const collectedAmount = project?.collected_amount || 0;
    const [startCountCollected, setStartCountCollected] = useState(collectedAmount);

    if (!project) {
        return null;
    }

    return (
        <CountUp
            start={startCountCollected}
            end={collectedAmount}
            onEnd={() => setStartCountCollected(collectedAmount)}
            formattingFn={formattingFn}
            duration={duration}
            preserveValue={true}
        />
    );
};

export default CollectedAmountAnimated;
